import React, { Component } from 'react'
import moment from 'moment'
import {
  DatePicker,
  Form,
  Input,
  Select,
  Spin,
  message,
  notification,
  Skeleton,
  Tabs,
} from 'antd'
import _ from 'lodash'
import $ from 'jquery'
import Errors from 'validatorjs/src/errors'

import AppHelper from 'libs/AppHelper'
import { API_HOST } from '../../configs/env'
import whttp from '../../libs/whttp'
import { genFormItemAtrribute } from 'libs/FormHelper'
import { __ } from '@wordpress/i18n'
import JsBarcode from 'jsbarcode'

const Local = _.get(window, 'VC_CONFIG.Locale')
const defaultListInfo = {
  current: 1, //目前頁數
  page_size: 10, //一頁幾筆
  total: 1, //以此query條件，總共幾筆資料
  rows: [],
}
const Option = Select.Option
const { TabPane } = Tabs
// 前端頁面
export default class UserProfile extends Component {
  formRef = React.createRef()
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
    isSubmitData: false,
    tableData: [],
    isLoading: false,
  }

  componentDidMount() {
    const { auth } = this.props

    //if (!auth && !auth.isLogin)
    //{
    //UAT
    //window.location.href= `https://toaccount.uni-prosperity.com.tw/C4TDMC/oauth/v2/authorization?response_type=code&client_id=b8f848827a0667870c436cca772b66a6&redirect_uri=https://cec.syscom.tw/sso/&state=C4&scope=read&device=1`;
    //正式機
    //window.location.href = `https://oaccount.uni-prosperity.com.tw/C4TDMC/oauth/v2/authorization?response_type=code&client_id=66baf15062e6d2bf305217507553ce8c&redirect_uri=${VC_CONFIG.INDEX_URL}/sso/&state=C4&scope=read&device=1`;
    //}

    AppHelper.updateConfig()

    this.setState({
      isFetchData: true,
      isLoading: true,
      info: this.props.user,
    })

    AppHelper.updateUserCardInfo(() => {
      this.setState({ isFetchData: false, isLoading: false }, () => {
        this.reloadTab()
      })
      this.getCardProfile()
    })
    // 登入換 tokne
    //http://cec.syscom.tw:8880/api/account/getAccessToken?code=4854c9565059992e98a33fbcde41597f
    // 電子發票列表
    // http://{{hostip}}//api/account/eInvoiceList
    // 點數紀錄 / 消費記錄
    // 密碼變更
    // 查詢編輯會員資料
    // 查詢好康卡會員資料
  }
  reloadTab = () => {
    // tab 共用動態
    var $el, leftPos, newWidth
    /* Add Magic Line markup via JavaScript, because it ain't gonna work without */
    let $magicLine = $('#magic-line')

    if (!_.get($magicLine, 0)) {
      console.log('kkk c', $magicLine)
      $('.basic-tabs-label ul').append("<li id='magic-line'></li>")
    }
    /* Cache it */
    $magicLine = $('#magic-line')

    $magicLine
      .width($('.current_page_item').width())
      .css('left', $('.current_page_item a').position().left)
      .data('origLeft', $magicLine.position().left)
      .data('origWidth', $magicLine.width())

    $('.basic-tabs-label ul li a').unbind('mouseenter mouseleave')
    $('.basic-tabs-label ul li')
      .find('a')
      .hover(
        function() {
          $el = $(this)
          console.log('basic-tabs-label', $el)
          leftPos = $el.position().left
          newWidth = $el.parent().width()

          $magicLine.stop().animate({
            left: leftPos,
            width: newWidth,
          })
        },
        function() {
          $magicLine.stop().animate({
            left: $magicLine.data('origLeft'),
            width: $magicLine.data('origWidth'),
          })
        }
      )

    $('#pills-tab .nav-item').unbind('mouseenter mouseleave')
    $('#pills-tab .nav-item')
      .mouseenter(function() {
        if (!$(this).hasClass('highlight')) {
          $('.highlight').removeClass('current_page_item')
        }
      })
      .mouseleave(function() {
        $('.highlight').addClass('current_page_item')
      })
  }
  pad = (num, n) => {
    let y = '00000000000000000000000000000' + num
    return y.substr(y.length - n)
  }
  fillData = (data) => {
    data.birthday =
      data.birth_year + '-' + data.birth_month + '-' + data.birth_day
    data.birthday = `${data.birth_year}-${data.birth_month}-${data.birth_day}`
    console.log('filldata-in', data)
    if (!this.formRef.current) return
    console.log('filldata-1111111111111')
    // 處理資料，本地適合Form Control的資料
    if (!_.isNil(data.addresses) || !_.isArray(data.addresses)) {
      //data.address = {
      //  city_id : _.get(data.addresses[0], 'city_id'),
      //  area_id : _.get(data.addresses[0], 'area_id'),
      //}
      data.street = _.get(data.addresses[0], 'street')
      console.log('filldata-2222222222222')
    }

    if (data.birth_day && data.birth_year && data.birth_month) {
      data.birthday = `${data.birth_year}-${this.pad(
        data.birth_month,
        2
      )}-${this.pad(data.birth_day, 2)}`
      console.log('filldata-birthday', data.birthday)
      data.birthday = moment(data.birthday, 'YYYY-MM-DD')
      console.log('filldata-birthday-moment', data.birthday)
    }
    console.log('filldata', data)

    this.formRef.current.setFieldsValue(data)
  }

  submitData = (info = {}) => {
    info.addresses = [
      {
        //city_id : _.get(info,'address.city_id'),
        //area_id : _.get(info, 'address.area_id'),
        city_id: null,
        area_id: null,
        street: _.get(info, 'street'),
      },
    ]
    console.log('submitdata', info)
    info.birthday = moment(_.get(info, 'birthday')).format('YYYY-MM-DD')
    info.birth_year = moment(info.birthday).format('YYYY')
    info.birth_month = moment(info.birthday).format('M')
    info.birth_day = moment(info.birthday).format('D')
    //info.flag  = _.get(info, 'flag') ? 1 : 0
    //info.agree_receive_sms  = _.get(info, 'agree_receive_sms') ? 1 : 0
    //info.sync_to_cls  = _.get(info, 'sync_to_cls') ? 1 : 0
    //delete info['address']
    delete info['birthday']
    this.setState({ isSubmitData: true, messages: {} })

    whttp.post(API_HOST + `/api/account/updCardProfile`, info, (state, res) => {
      console.log(state, res)
      this.setState({ isSubmitData: false })

      const { code = 100, reason = '發生錯誤', data = {} } = res

      if (state === false) {
        return message.error('發生錯誤')
      }

      if (code !== 200) {
        notification['error']({
          message: '更新失敗',
          description: reason,
        })

        return this.setState({ messages: data.messages || {} })
      }

      notification['success']({
        message: '修改成功',
      })
      window.location.href = window.VC_CONFIG.INDEX_URL + '/loyaltyprofile'
    })
  }

  getCardProfile = () => {
    const query = AppHelper.getHashParamaters()

    this.setState({ isFetchData: true })

    whttp.sharedGet(API_HOST + `/api/account/getProfiles`, {}, (state, res) => {
      this.setState({ isFetchData: false })

      const { code = 100, reason = '發生錯誤', data = {} } = res

      console.log(code, reason, data, res)

      if (state === false || code !== 200) {
        message.warning(reason)
        //this.props.history.replace("/brands")
        return
      }

      this.setState({ tableData: data })
      console.log('getCardProfile', data)
      this.fillData(data.cardProfile)
    })
  }
  render() {
    const errors = _.get(this, 'state.validator.errors', new Errors())
    const options = _.get(this, 'props.app.options', {})
    const { info, tableData } = this.state
    const profile = tableData.profile
    const cardProfile = tableData.cardProfile

    return (
      <div>
        {this.state.isLoading ? (
          <Spin>
            <div
              class='row justify-content-center'
              style={{ minHeight: 200 }}
            />
          </Spin>
        ) : (
          <main className='bg-light'>
            <div className='container'>
              <section className='pt-2 pb-2'>
                <div className='breadcrumb-wrap'>
                  <nav aria-label='breadcrumb'>
                    {Local == 'zh_TW' && (
                      <ol className='breadcrumb'>
                        <li className='breadcrumb-item'>
                          <a href={`${window.VC_CONFIG.INDEX_URL}/`}>
                            {__('首頁', 'cec-plugin-stores')}
                          </a>
                        </li>
                        <li className='breadcrumb-item'>
                          <a href={`${window.VC_CONFIG.INDEX_URL}/profile`}>
                            {__('會員中心', 'cec-plugin-stores')}
                          </a>
                        </li>
                        <li
                          className='breadcrumb-item active'
                          aria-current='page'>
                          {__('好康卡會員資料', 'cec-plugin-stores')}
                        </li>
                      </ol>
                    )}
                    {Local == 'en_US' && (
                      <ol className='breadcrumb'>
                        <li className='breadcrumb-item'>
                          <a href={`${window.VC_CONFIG.INDEX_URL}/en`}>
                            {__('首頁', 'cec-plugin-stores')}
                          </a>
                        </li>
                        <li className='breadcrumb-item'>
                          <a
                            href={`${
                              window.VC_CONFIG.INDEX_URL
                            }/profile-en`}>
                            {__('會員中心', 'cec-plugin-stores')}
                          </a>
                        </li>
                        <li
                          className='breadcrumb-item active'
                          aria-current='page'>
                          {__('好康卡會員資料', 'cec-plugin-stores')}
                        </li>
                      </ol>
                    )}
                  </nav>
                </div>
                <h6 className='h5 lh-h4 mb-5 text-navy text-lg-left text-center'>
                  {__('親愛的', 'cec-plugin-stores')}{' '}
                  <b className='fw-700'>{info && info.cn_name}</b>
                  <br className='d-block d-lg-none' />
                  {__('您好，歡迎來到會員中心！', 'cec-plugin-stores')}
                </h6>
              </section>
            </div>
            <section className='pt-0'>
              <div className='mb-5 basic-tabs-label'>
                {Local == 'zh_TW' && (
                  <ul className='nav nav-pills' id='pills-tab'>
                    <li className='nav-item'>
                      <a
                        className='nav-link'
                        href={`${window.VC_CONFIG.INDEX_URL}/profile`}>
                        {__('網站帳號', 'cec-plugin-stores')}
                      </a>
                    </li>
                    {info && info.spcode === 'C4' && (
                      <li className='nav-item'>
                        <a
                          className='nav-link'
                          href={`${window.VC_CONFIG.INDEX_URL}/pwd`}>
                          {__('更改密碼', 'cec-plugin-stores')}
                        </a>
                      </li>
                    )}
                    <li className='nav-item current_page_item highlight'>
                      <a className='nav-link'>
                        {__('好康卡會員資料', 'cec-plugin-stores')}
                      </a>
                    </li>
                    {/* <li className='nav-item'>
                      <a
                        className='nav-link'
                        href={`${window.VC_CONFIG.INDEX_URL}/payment`}
                      >
                        {__('我的消費紀錄', 'cec-plugin-stores')}
                      </a>
                    </li> */}
                    <li className='nav-item'>
                      <a
                        className='nav-link'
                        href={`${window.VC_CONFIG.INDEX_URL}/point`}>
                        {__('點數紀錄', 'cec-plugin-stores')}
                      </a>
                    </li>
                    <li className='nav-item'>
                      <a
                        className='nav-link'
                        href={`${window.VC_CONFIG.INDEX_URL}/invoice`}>
                        {__('電子發票記錄', 'cec-plugin-stores')}
                      </a>
                    </li>
                    <li className='nav-item'>
                      <a
                        className='nav-link'
                        href={`${window.VC_CONFIG.INDEX_URL}/connect`}>
                        {__('第三方登入設定', 'cec-plugin-stores')}
                      </a>
                    </li>
                  </ul>
                )}
                {Local == 'en_US' && (
                  <ul className='nav nav-pills' id='pills-tab'>
                    <li className='nav-item'>
                      <a
                        className='nav-link'
                        href={`${window.VC_CONFIG.INDEX_URL}/profile-en`}>
                        {__('網站帳號', 'cec-plugin-stores')}
                      </a>
                    </li>
                    {info && info.spcode === 'C4' && (
                      <li className='nav-item'>
                        <a
                          className='nav-link'
                          href={`${window.VC_CONFIG.INDEX_URL}/pwd-en`}>
                          {__('更改密碼', 'cec-plugin-stores')}
                        </a>
                      </li>
                    )}
                    <li className='nav-item current_page_item highlight'>
                      <a className='nav-link'>
                        {__('好康卡會員資料', 'cec-plugin-stores')}
                      </a>
                    </li>
                    {/* <li className='nav-item'>
                      <a
                        className='nav-link'
                        href={`${window.VC_CONFIG.INDEX_URL}/payment-en`}
                      >
                        {__('我的消費紀錄', 'cec-plugin-stores')}
                      </a>
                    </li> */}
                    <li className='nav-item'>
                      <a
                        className='nav-link'
                        href={`${window.VC_CONFIG.INDEX_URL}/point-en`}>
                        {__('點數紀錄', 'cec-plugin-stores')}
                      </a>
                    </li>
                    <li className='nav-item'>
                      <a
                        className='nav-link'
                        href={`${window.VC_CONFIG.INDEX_URL}/invoice-en`}>
                        {__('電子發票記錄', 'cec-plugin-stores')}
                      </a>
                    </li>
                    <li className='nav-item'>
                      <a
                        className='nav-link'
                        href={`${window.VC_CONFIG.INDEX_URL}/connect-en`}>
                        {__('第三方登入設定', 'cec-plugin-stores')}
                      </a>
                    </li>
                  </ul>
                )}
              </div>
              <div className='container'>
                <div className='row no-gutters mx-n3 mb-4'>
                  <div className='col-lg-3 px-3'>
                    <div className='card border-0 shadow-0 h-100'>
                      <div className='card-body p-5'>
                        <div className='row justify-content-center'>
                          <div className='col-6 col-lg-9'>
                            <img
                              className='img-fluid'
                              src={`${
                                window.VC_CONFIG.INDEX_URL
                              }/wp-content/themes/cec/assets/img/member/card0${
                                info && info.vip_flag == 0 ? '1' : '2'
                              }.svg`}
                              alt=''
                            />
                          </div>
                        </div>
                        <h5 className='h4 text-navy text-center mb-0'>
                          {__('好康卡', 'cec-plugin-stores')}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div className='col-lg-9 px-3'>
                    <div className='card border-0 shadow-0 h-100'>
                      <div className='card-body p-5'>
                        <div className='row'>
                          <div className='col-sm-5'>
                            <p className='h6 text-navy fw-700 mb-2'>
                              {__('會員等級', 'cec-plugin-stores')}：
                              {profile && profile.vip_flag == 0
                                ? __('一般會員', 'cec-plugin-stores')
                                : __('VIP會員', 'cec-plugin-stores')}
                            </p>
                            <p className='h6 text-navy fw-700 mb-2'>
                              {__('連結會員卡號', 'cec-plugin-stores')}：
                              {profile &&
                                profile.cardInfo &&
                                profile.cardInfo.cardnumber}
                            </p>
                            <p className='h6 text-navy fw-700 mb-2'>
                              {__('目前點數記錄', 'cec-plugin-stores')}：
                              {profile &&
                                profile.point_balance &&
                                profile.point_balance
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                              {__('點', 'cec-plugin-stores')}
                            </p>
                            <p className='h6 text-navy fw-700 mb-2'>
                              {__('可兌換金額', 'cec-plugin-stores')}：
                              {Local == 'en_US' && '$'}
                              {profile &&
                                profile.amt_balance &&
                                profile.amt_balance
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                              {Local == 'zh_TW' && '元'}
                            </p>
                          </div>
                          <div className='col-sm-7'>
                            <p className='h6 text-navy fw-700 mb-2'>
                              {__('最新消費日', 'cec-plugin-stores')}：
                              {(profile &&
                                profile.lastPurInfo &&
                                moment(profile.lastPurInfo.pur_dt).format(
                                  'YYYY/MM/DD',
                                )) ||
                                __('無', 'cec-plugin-stores')}
                            </p>
                            <p className='h6 text-navy fw-700 mb-2'>
                              {__('最近消費分店', 'cec-plugin-stores')}：
                              {(profile &&
                                profile.lastPurInfo &&
                                profile.lastPurInfo.pur_store) ||
                                __('無', 'cec-plugin-stores')}{' '}
                            </p>
                            <p className='h6 text-navy fw-700 mb-2'>
                              {__('最近消費金額', 'cec-plugin-stores')}：
                              {Local == 'en_US' && '$'}
                              {(profile &&
                                profile.lastPurInfo &&
                                profile.lastPurInfo.pur_amount &&
                                profile.lastPurInfo.pur_amount
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')) ||
                                '0'}
                              {Local == 'zh_TW' && '元'}
                            </p>
                          </div>
                          <div className='col-12 mt-5'>
                            <p className='h6 text-success'>
                              {__(
                                '正確點數將於消費之24小時後更新,如遇系統或資料更新, 以實際作業為準。',
                                'cec-plugin-stores',
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row no-gutters mx-n3 mb-4'>
                  <div className='col-lg-3 px-3'>
                    <div className='card border-0 shadow-0 h-100'>
                      <div className='card-body pb-0 pt-5 p-lg-5'>
                        <h5 className='h4 text-navy text-center'>
                          {__('好康卡會員資料', 'cec-plugin-stores')}
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div className='col-lg-9 px-3'>
                    <Spin spinning={this.state.isSubmitData}>
                      <Skeleton loading={this.state.isFetchData}>
                        <Form
                          noStyle
                          ref={this.formRef}
                          name='basic'
                          layout='vertical'
                          onFinish={(values) => this.submitData(values)}
                          onValuesChange={(changedFields, allFields) => {
                            console.log(
                              'onValuesChange:',
                              changedFields,
                              allFields,
                            )
                          }}
                          // onFinishFailed={errorInfo => console.log('onFinishFailed:', errorInfo)}
                          // onFieldsChange={(changedFields, allFields) => {
                          //     const storeInfo = _.reduce(allFields,(obj,item) => {
                          //         _.set(obj, item.name.join('.'), item.value)
                          //         return obj
                          //       }, {})
                          //       console.log('onFieldsChange:', storeInfo, changedFields, allFields)
                          //       return true
                          //     }}
                        >
                          <div className='card border-0 shadow-0 h-100'>
                            <div className='card-body p-5'>
                              {info && info.spcode === 'C4' && (
                                <div className='form-group mb-4 row align-items-center'>
                                  <label
                                    className='col-sm-2 col-form-label h6 text-navy'
                                    for=''>
                                    {__('帳號', 'cec-plugin-stores')}*
                                  </label>
                                  <div className='col-sm-10'>
                                    <input
                                      className='form-control'
                                      type='text'
                                      disabled='disabled'
                                      readonly=''
                                      value={info && info.email}
                                      id=''
                                    />
                                  </div>
                                </div>
                              )}
                              <div className='form-group mb-4 row align-items-center'>
                                <label
                                  className='col-sm-2 col-form-label h6 text-navy'
                                  for=''>
                                  {__('中文姓名', 'cec-plugin-stores')}*
                                </label>
                                <div className='col-sm-10'>
                                  <Form.Item
                                    rules={[
                                      {
                                        required: true,
                                        message: __(
                                          '請輸入中文姓名',
                                          'cec-plugin-stores',
                                        ),
                                      },
                                    ]}
                                    {...genFormItemAtrribute('full_cname')}>
                                    <Input className='form-control' />
                                  </Form.Item>
                                </div>
                              </div>
                              <div className='form-group mb-4 row align-items-center'>
                                <label
                                  className='col-sm-2 col-form-label h6 text-navy'
                                  for=''>
                                  {__('英文姓名', 'cec-plugin-stores')}
                                </label>
                                <div className='col-sm-10'>
                                  <Form.Item
                                    {...genFormItemAtrribute('full_ename')}>
                                    <Input className='form-control' />
                                  </Form.Item>
                                </div>
                              </div>
                              <div className='form-group mb-4 row align-items-center'>
                                <label
                                  className='col-sm-2 col-form-label h6 text-navy'
                                  for=''>
                                  {__('生日', 'cec-plugin-stores')}＊
                                </label>
                                <div className='col-sm-10'>
                                  <Form.Item
                                    rules={[
                                      {
                                        required: true,
                                        message: __(
                                          '請選擇生日',
                                          'cec-plugin-stores',
                                        ),
                                      },
                                    ]}
                                    {...genFormItemAtrribute(
                                      'birthday',
                                      null,
                                    )}>
                                    <DatePicker
                                      placeholder={__(
                                        '請選擇生日',
                                        'cec-plugin-stores',
                                      )}
                                      className='form-control'
                                      format='YYYY-MM-DD'
                                      disabled
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                              <div className='form-group mb-4 row align-items-center'>
                                <label
                                  className='col-sm-2 col-form-label h6 text-navy'
                                  for=''>
                                  {__('地址', 'cec-plugin-stores')}*
                                </label>
                                <div className='col-sm-10'>
                                  <Form.Item label=''>
                                    <Input.Group compact>
                                      <Form.Item
                                        name='street'
                                        noStyle
                                        className='form-control'
                                        rules={[
                                          {
                                            required: true,
                                            message: __(
                                              '請輸入地址',
                                              'cec-plugin-stores',
                                            ),
                                          },
                                        ]}>
                                        <Input
                                          style={{ width: '70%' }}
                                          placeholder={__(
                                            '請輸入地址',
                                            'cec-plugin-stores',
                                          )}
                                        />
                                      </Form.Item>
                                    </Input.Group>
                                  </Form.Item>
                                </div>
                              </div>
                              <div className='form-group mb-4 row align-items-center'>
                                <label
                                  className='col-sm-2 col-form-label h6 text-navy'
                                  for=''>
                                  {__('手機', 'cec-plugin-stores')}*
                                </label>
                                <div className='col-sm-10'>
                                  <Form.Item
                                    rules={[
                                      {
                                        required: true,
                                        pattern: new RegExp('^[0-9]{10}$'),
                                        message: __(
                                          '請輸入正確手機號碼',
                                          'cec-plugin-stores',
                                        ),
                                      },
                                    ]}
                                    {...genFormItemAtrribute('mobile')}>
                                    <Input className='form-control' />
                                  </Form.Item>
                                </div>
                              </div>
                              <div className='form-group mb-4 row align-items-center'>
                                <label
                                  className='col-sm-2 col-form-label h6 text-navy'
                                  for=''>
                                  {__('居住電話', 'cec-plugin-stores')}
                                </label>
                                <div className='col-sm-10'>
                                  <Form.Item
                                    {...genFormItemAtrribute('home_phone')}>
                                    <Input className='form-control' />
                                  </Form.Item>
                                </div>
                              </div>
                              <div className='form-group mb-4 row align-items-center'>
                                <label
                                  className='col-sm-2 col-form-label h6 text-navy'
                                  for=''>
                                  {__('公司電話', 'cec-plugin-stores')}
                                </label>
                                <div className='col-sm-10'>
                                  <Form.Item
                                    {...genFormItemAtrribute(
                                      'company_phone',
                                    )}>
                                    <Input className='form-control' />
                                  </Form.Item>
                                </div>
                              </div>
                              <div className='form-group mb-4 row align-items-center'>
                                <label
                                  className='col-sm-2 col-form-label h6 text-navy'
                                  for=''>
                                  {__('電子信箱', 'cec-plugin-stores')}*
                                </label>
                                <div className='col-sm-10'>
                                  <Form.Item
                                    rules={[
                                      {
                                        required: true,
                                        message: '請輸入信箱',
                                      },
                                    ]}
                                    {...genFormItemAtrribute('email')}>
                                    <Input className='form-control' />
                                  </Form.Item>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Form>
                      </Skeleton>
                    </Spin>
                  </div>
                </div>

                <div className='row no-gutters mx-n3 mb-4'>
                  <div className='col-lg-3 px-3'>
                    <div className='card border-0 shadow-0 h-100'>
                      <div className='card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'>
                        <h5 className='h4 text-navy text-center'>
                          {__('注意事項', 'cec-plugin-stores')}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div className='col-lg-9 px-3'>
                    <div className='card border-0 shadow-0 h-100'>
                      <div className='card-body p-5'>
                        <p className='h6 text-navy text-justify'>
                          {__(
                            '如您發現姓名或生日與您申請資料不符，請與客服中心聯絡作資料的修改，以確保會員資料的正確 性。客服中心：市話 0809-001-365 / 手機(02)8006-9999',
                            'cec-plugin-stores',
                          )}
                        </p>
                        <p className='h6 text-navy text-justify'>
                          {__(
                            '※ 由於促銷目錄為提前印製，故於 網站更新個人地址後，目錄寄件資料更新約需30個工作天，造成您不便之處盼您見諒！！ ',
                            'cec-plugin-stores',
                          )}
                        </p>
                        <p className='h6 text-navy text-justify'>
                          {__(
                            '※ 如需取消促銷目錄寄送的服務，請與客服中心聯絡，將有專人為您提供服務。',
                            'cec-plugin-stores',
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='text-center mt-5'>
                  <a
                    className='h6 btn btn-outline-primary rounded-pill px-5 py-4'
                    role='button'
                    onClick={(e) => {
                      e.preventDefault()
                      this.formRef.current.submit()
                    }}>
                    {__('確定修改', 'cec-plugin-stores')}
                  </a>
                </div>
              </div>
            </section>
          </main>
        )}
      </div>
    )
  }
}

$(document).ready(function() {
  JsBarcode('.barcode').init()
})

// 編輯器
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 }
export class UserProfileEditor extends Component {
  formRef = React.createRef()
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  }
  componentDidMount() {
    AppHelper.updateConfig()
    console.log('kkk', this.props.attributes)

    this.formRef.current.setFieldsValue(this.props.attributes)
  }
  render() {
    const listInfo = this.state.listInfo
    const options = _.get(this, 'props.app.options', {})
    console.log('editor', this.props)

    return (
      <div className='wp-block-cec-vulcan-block-catalogue-list-editor'>
        <h2>會員資訊模組</h2>
        <Form ref={this.formRef} name='basic' className='basicForm' />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/blocks/users/user-loyaltyprofile.js